<div class="content-container mb-3">
  <div class="title pb-0">
    {{title}}
  </div>
  <div class="content">
    @if (!widgetError) { 
      <div class="message-container blue-fill mb-3">
        <mwp-text-translate text="Category complete! Your request has been recorded." jsonKey="categoryFinalize1" />
      </div>
    }
    @if (widgetError) {
      <div class="message-container error mb-3">
        <div class="header fw-bold mb-3">{{widgetErrorModel.title}}</div>
        <div class="text-center">{{widgetErrorModel.message}}</div>
      </div>
    }
    @if (isCheckoutEnabled) {
      <div class="mb-3">
        <diV class="mb-3 px-2">
          <mwp-text-translate text="To move on to the next step, click GO TO NEXT CATEGORY, or, if available, you are wanting to complete your enrollment session, click on CHECKOUT." jsonKey="categoryFinalize2" />
        </diV>
        <div class="message-card green">
          <mwp-text-translate text="Checkout is now available. Remember, you must complete the Checkout process, or your requests will not be processed." jsonKey="categoryFinalize3" />
        </div>
      </div>
    }
    @if (!isCheckoutEnabled) {
      <div class="mb-3">
        <div class="mb-3 px-2">
          <mwp-text-translate text="Please select an option below to continue." jsonKey="categoryFinalize4" />
        </div>
        <div class="message-card orange">
          <span class="fw-bold">
            <mwp-text-translate text="Checkout is not yet available. Remember, you must complete all required categories and the Checkout process, or your requests will not be processed." jsonKey="categoryFinalize5" />
          </span>
        </div>
        @if (nextCategory?.isRequired) {
          <div class="mt-3 message-card red">
            <mwp-text-translate text="Next Category is required before CHECKOUT is accesible." jsonKey="categoryFinalize6" />
          </div>
        }
      </div>
    }
  </div>
  <div class="footer pt-0 no-border">
    <div class="d-inline-flex justify-content-end w-100">
      <button class="mwp-button-secondary" (click)="stayOnCategory()">
        <mwp-text-translate text="Return to Current Category" jsonKey="returnToCurrentCategory" />
      </button>
      @if (nextCategory) {
        <button class="mwp-button ms-3" (click)="gotoNextCategory()">
          <mwp-text-translate text="Next Category" jsonKey="nextCategory" />
        </button>
      }
      <button class="mwp-button-save ms-3" [disabled]="!isCheckoutEnabled" (click)="goToCheckout()">
        <mwp-text-translate text="Checkout" jsonKey="checkout" />
      </button>
    </div>
  </div>
</div>
